import { createElementBlock as t, openBlock as l, createElementVNode as o } from "vue";
import n from "../../../../_virtual/_plugin-vue_export-helper.js";
const r = {}, c = {
  fill: "none",
  viewBox: "0 0 20 20",
  xmlns: "http://www.w3.org/2000/svg"
};
function f(a, e) {
  return l(), t("svg", c, [...e[0] || (e[0] = [
    o("rect", {
      fill: "#2C7ACD",
      height: "20",
      rx: "4",
      width: "20"
    }, null, -1),
    o("path", {
      "clip-rule": "evenodd",
      d: "M4.64 7.03h10.753a.39.39 0 1 0 0-.78H4.64a.39.39 0 1 0 0 .78Zm0 2.33h10.753a.39.39 0 0 0 0-.78H4.64a.39.39 0 1 0 0 .78Zm10.753 2.33H4.64a.389.389 0 0 1-.39-.39.39.39 0 0 1 .39-.39h10.753a.39.39 0 1 1 0 .78ZM4.64 14.02h6.51a.39.39 0 1 0 0-.78H4.64a.39.39 0 0 0 0 .78Z",
      fill: "#fff",
      "fill-rule": "evenodd"
    }, null, -1)
  ])]);
}
const s = /* @__PURE__ */ n(r, [["render", f]]);
export {
  s as default
};
